import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-text-bold",
  "use": "foquz-icon-text-bold-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol viewBox=\"0 0 15 18\" fill=\"none\" id=\"foquz-icon-text-bold\"><path d=\"M1 9h8a4 4 0 100-8H1v8zm0 0h9a4 4 0 110 8H1V9z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol